// extracted by mini-css-extract-plugin
export default {"img":"img__6UaZT","closeButton":"closeButton__oh9A5","leading":"leading__7ucMB","actionButton":"actionButton__TIIKV"};